// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1 2.5H9.48063L11.4806 5H23V21H11.2678C11.7356 20.1025 12 19.0821 12 18C12 14.4102 9.08985 11.5 5.5 11.5C3.75351 11.5 2.16789 12.1888 1 13.3096V2.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10.9083 18.002L6.04998 13.0878L4.62771 14.4939L7.10728 17.002L-0.00195312 17.002V19.002L7.10728 19.002L4.62771 21.5101L6.04999 22.9162L10.9083 18.002Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-import-filled')
export default class FolderImportFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-import-filled',
    }
  }
}
